import React, { useMemo, useState } from 'react'
import Select from 'react-select';
import { isBlank } from '../components/commonClass/CommonValidation';

const CommonFilter = (props: any) => {

    const { filtercolumns, filteritems,
        setFilterList, getdata, serchdisable,
        setSearchValue, searchvalue, setSerachBy, searchby } = props;

    const [clrshow, setsclshow] = useState(false);

    const searchList = useMemo(() => {
        let list = filtercolumns?.filter((fil: any) => !isBlank?.includes(fil?.key) && !fil?.omit && fil?.isSearch)?.map((obj: any) => { return { label: obj?.name || obj?.Name, value: obj?.key || obj?.Key } })
        return [...list, { label: "All", value: "All" }];
    }, [filtercolumns])

    const Keys = useMemo(() => {
        return filtercolumns?.filter((fil: any) => !isBlank?.includes(fil?.key) && !fil?.omit && fil?.isSearch)?.map((obj: any) => obj.key)
    }, [filtercolumns])

    const handleSearchBy = (e: any) => {
        setSerachBy(e.value);
    }

    const onKeyDownHandler = (e: any) => {
        if (e.keyCode === 13) {
            handleSearch();
        }
    }

    const handleChangeSearchValue = (e: any) => {
        setSearchValue(e.target.value)
        setsclshow(true)
        if (e.target.value === '') {
            getdata();
            setsclshow(false);
        }
    }

    const clearsearch = () => {
        setSearchValue("");
        setsclshow(false);
        getdata();
    }

    const matchesSearchValueAll = (issec: any, fields: any) => {
        let search = searchvalue
        return fields?.some((data: any) =>
            issec[data]?.toString()?.toLowerCase()?.includes(search?.toLowerCase())
        );
    };

    const handleSearch = () => {
        if (searchvalue?.trim()?.length !== 0) {
            var filterdata;
            if (searchby === "All") {
                filterdata = filteritems?.filter((issec: any) => {
                    return matchesSearchValueAll(issec, Keys) && issec
                });
            }
            else {
                filterdata = filteritems?.filter((item: any) =>
                    item[searchby]?.toString()?.toLowerCase()?.includes(searchvalue?.toLowerCase())
                );
            }
            setFilterList(filterdata)
        }
    }

    return (
        <>
            <div className="row justify-content-end mx-2 mt-3">
                <div className="py-2 px-1 col-lg-2 col-md-4 col-sm-12">
                    <Select
                        className="dropdown custom_class"
                        options={searchList}
                        value={searchList?.filter(function (searchList) {
                            return searchList.value === searchby;
                        })}
                        onChange={handleSearchBy}
                        isDisabled={serchdisable ? true : false}
                        isSearchable={false}

                    />
                </div>
                <div className="py-2 px-1 col-lg-2 col-md-4 col-sm-12">
                    <div className='clrbutton'>
                        <input
                            type="text"
                            onKeyDown={onKeyDownHandler}
                            id="btnSearchText"
                            className="form-control"
                            placeholder='Enter keyword'
                            name="SearchValue"
                            onChange={handleChangeSearchValue}
                            value={searchvalue || ''}
                            disabled={serchdisable ? true : false}
                            autoComplete='off'
                        />
                        <button className={`${clrshow === true ? "d-block" : "d-none"}`} disabled={serchdisable ? true : false} onClick={clearsearch} type="reset">&times;</button>
                    </div>
                </div>
                <div className="py-2 px-1 text-center col-auto">
                    <button type="button" className="btn btn-primary" id="btnSearch" disabled={serchdisable ? true : false} onClick={handleSearch}>Search</button>
                </div>
            </div>
        </>
    )
}

export default CommonFilter